(function() { window.GUID_ac6ce0fb_0e07_4754_b400_958a5448098d = { getGuid: function() { return "ac6ce0fb-0e07-4754-b400-958a5448098d"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class GaugeChart extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                const me = this;
            }
            OnBindEvents() {
            }
            OnDispose() {
            }
        }
        Controls.GaugeChart = GaugeChart;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=gauge-chart.js.map
